//=require node_modules/jquery/dist/jquery.js
//=require node_modules/bootstrap/dist/js/bootstrap.bundle.js
//=require static/src/static/js/vendor/jquery.hoverintent.min.js
//=require static/src/static/js/vendor/multilevel-nav.js
//=require static/src/static/js/vendor/speedbump.js
//=require static/src/static/js/Feedback.js
//=require static/src/static/js/SocialShare.js
//=require static/src/static/js/testimonialCarousel.js

(function ($) {
    "use strict";

    var navBar = $('.main-nav');

    navBar.multilevelNav({
        'hoverIntent': true,
        'hoverIntentTimeout': 300,
        'wholeLinkToggler': true,
        'toggleOnClickOnly': true,
        'navbarMegaMenuBackdrop': false,
        'menuCloseOnInPageAnchorClick': true,
        'excludeLevel': 3,
        'childMenuTogglerSymbol': '<span class="mln__toggle-btn__plus"></span>',
        'keepMenuOpenOnFocusOut': true,
    });

    // add class to body when mobile menu is open for backdrop styling
    var menuExpander = $('.mln__expander');

    menuExpander.on('showing.mln.expander', function () {
        $('body').addClass('js-backdrop-showing');
    });

    menuExpander.on('hiding.mln.expander', function () {
        $('body').removeClass('js-backdrop-showing');
    });

    // close mega menu when close button is clicked
    let megaMenuCloseBtn = $('.main-nav .btn-close');

    megaMenuCloseBtn.each(function () {
        $(this).on('click', function () {
            $(this)
                .closest('.mln__has-child--showing')
                .find('.mln__toggle-link[aria-expanded="true"]')
                .first()
                .trigger('click');
        });
    });

    // close mega menu when search is clicked
    $('#navSearchCollapseToggle').on('click', function () {
        if ($(window).width() > 992) {
            $('.mln__toggle-link[aria-expanded="true"]').trigger('click'); //close mega menus if open
        }
    });

    // close search collapse if clicking outside it
    $(document).mouseup(function (e) {
        if (!$(e.target).is('.nav-search__collapse, .nav-search__collapse *')) {
            $("#navSearchCollapse").collapse('hide');
        }
    });

    // jump focus to search input when search collapse is expanded
    $('#navSearchCollapse').on('shown.bs.collapse', event => {
        $('#siteSearchInput').focus();
    });

    let signInCollapsePage = $('body');
    let signInCollapse = $('#signInCollapse');

    signInCollapse.on('show.bs.collapse', event => {
        signInCollapsePage.addClass('sign-in-backdrop-showing');
    });

    signInCollapse.on('hide.bs.collapse', event => {
        if ($(event.target).attr('id') !== 'servicesCollapse') {
            signInCollapsePage.removeClass('sign-in-backdrop-showing');
        }
    });

    // close sign in collapse if clicking outside it
    $(document).mouseup(function (e) {
        if (!$(e.target).is('.sign-in-menu__collapse, .sign-in-menu__collapse *')) {
            $("#signInCollapse").collapse('hide');
        }
    });

    var mainNavBreakPoint = $('.main-nav').attr('data-mln-breakpoint');

    // close mega menu when sign in toggle is clicked
    $('#signInCollapseToggle').on('click', function () {
        if (window.matchMedia('(min-width: ' + mainNavBreakPoint + 'px)').matches) {
            $('.mln__toggle-link[aria-expanded="true"]').trigger('click'); //close mega menus if open
        }
    });

    // close mobile menu when sign in toggle is clicked
    $('#signInCollapseToggle').on('click', function () {
        if (window.matchMedia('(max-width: ' + (mainNavBreakPoint - 1) + 'px)').matches) {
            $('.mln__expand-btn[aria-expanded="true"]').trigger('click'); //close mobile menu if open
        }
    });

    // Back to top button functionality ----------------------------
    var target = document.querySelector("header");

    var scrollToTopBtn = document.querySelector("#backToTopBtn");
    var rootElement = document.documentElement;

    // Create a function that will be called when that element is intersected
    function callback(entries, observer) {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                // Hide button
                scrollToTopBtn.classList.remove("back-to-top--showing");
            } else {
                // Show button
                scrollToTopBtn.classList.add("back-to-top--showing");
            }
        });
    }

    function scrollToTop() {
        rootElement.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }
    scrollToTopBtn.addEventListener("click", scrollToTop);

    // Instantiate the observer
    let observer = new IntersectionObserver(callback);
    // Start observing the target element
    observer.observe(target);

    // Thumb feedback controls -----------------------------------
    $('.btn-feedback--no').on('click', function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
        } else {
            $(this).closest('.feedback-controls').find('.btn-feedback').removeClass('active');
            $(this).addClass('active');
        }
    });

    $('.btn-feedback--yes').on('click', function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
        } else {
            $(this).closest('.feedback-controls').find('.btn-feedback').removeClass('active');
            $(this).addClass('active');
        }
    });

    // Single click card --------------------------------------------
    var clickableCards = $('.single-click');
    clickableCards.each(function () {
        var $this = $(this),
            imgLink = $this.find('a img'),
            down,
            up,
            link = $this.find('a'),
            auxClick;

        if (imgLink.length) {
            imgLink.unwrap();
        }

        $this.on('mousedown', function (e) {
            down = +new Date();
            auxClick = false;

            if (e.which === 3) {
                auxClick = true;
            }
        }).on('mouseup', function () {
            up = +new Date();

            if ((up - down) < 200 && auxClick === false) {
                link[0].click();
            }
        });
    });

    // Comparison table functions ----------------------------------------------
    function buildDots() {
        var width = $(window).width();
        var thisColumn = $('.comparison-block__content .compare-item');
        var theDots = $('.compare-dot-list compare-dot-list__dot');
        var colCount = $(thisColumn).length;

        // Add the dots
        $( ".comparison-block__content .compare-item" ).each(function( i ) {
            $('<li class="compare-dot-list__dot"></li>').appendTo('.compare-dot-list');
        });

        if (width < 768) {
            // console.log('Less than 768px');
            $('.compare-dot-list li:nth-child(1)').addClass('active');
        }
        if (width < 1200 && width > 767) {
            // console.log('Less than 1200px');
            $('.compare-dot-list li:nth-child(1), .compare-dot-list li:nth-child(2)').addClass('active');
            if (colCount < 3) {
                $('.comparison-block__nav').addClass('d-none');
                $('.comparison-block__content').css('justify-content', 'center');
            }
        }
        if (width < 1400 && width > 1199) {
            // console.log('Less than 1400px');
            $('.compare-dot-list li:nth-child(1), .compare-dot-list li:nth-child(2), .compare-dot-list li:nth-child(3)').addClass('active');
            if (colCount < 4) {
                $('.comparison-block__nav').addClass('d-none');
                $('.comparison-block__content').css('justify-content', 'center');
            }
        }
        if (width < 1700 && width > 1399) {
            // console.log('Less than 1700px');
            $('.compare-dot-list li:nth-child(1), .compare-dot-list li:nth-child(2), .compare-dot-list li:nth-child(3), .compare-dot-list li:nth-child(4)').addClass('active');
            if (colCount < 5) {
                $('.comparison-block__nav').addClass('d-none');
                $('.comparison-block__content').css('justify-content', 'center');
            }
        }
        if (width < 2200 && width > 1699) {
            // console.log('Less than 2200px');
            $('.compare-dot-list li:nth-child(1), .compare-dot-list li:nth-child(2), .compare-dot-list li:nth-child(3), .compare-dot-list li:nth-child(4), .compare-dot-list li:nth-child(5)').addClass('active');
            if (colCount < 6) {
                $('.comparison-block__nav').addClass('d-none');
                $('.comparison-block__content').css('justify-content', 'center');
            }
        }
        if (width > 2199) {
            // console.log('2200px or more');
            $('.compare-dot-list li:nth-child(1), .compare-dot-list li:nth-child(2), .compare-dot-list li:nth-child(3), .compare-dot-list li:nth-child(4), .compare-dot-list li:nth-child(5), .compare-dot-list li:nth-child(6)').addClass('active');
            if (colCount < 7) {
                $('.comparison-block__nav').addClass('d-none');
                $('.comparison-block__content').css('justify-content', 'center');
            }
        }
    };

    function equalizeHeaders() {
        var headHeight = 0;
        $( ".comparison-block__content .compare-item" ).each(function( i ) {
            $(this).find('.compare-item__header').removeAttr('style');
            var tempHeight = Math.ceil($(this).find('.compare-item__header').outerHeight());
            if (tempHeight > headHeight) {
                headHeight = tempHeight;
            }
        });
        $( ".comparison-block__content .compare-item .compare-item__header" ).each(function( i ) {
            $(this).css('min-height', headHeight);
        });
    };

    function columnAdjust() {
        var width = $(window).width();
        var theDots = $('.compare-dot-list .compare-dot-list__dot');
        var thisColumn = $('.comparison-block__content .compare-item');
        var colCount = $(thisColumn).length;
        var currentPosition = $('.comparison-block__content').scrollLeft();
        var colWidth = $('.compare-item').width();
        var currentCol = Math.round(currentPosition / colWidth);

        if (width < 768) {
            $('.comparison-block__nav').removeClass('d-none');
            $('.comparison-block__content').css('justify-content', 'flex-start');
        }
        if (width < 1200 && width > 767) {
            if (colCount < 3) {
                $('.comparison-block__nav').addClass('d-none');
                $('.comparison-block__content').css('justify-content', 'center');
            }
            if (colCount >= 3) {
                $('.comparison-block__nav').removeClass('d-none');
                $('.comparison-block__content').css('justify-content', 'flex-start');
            }
        }
        if (width < 1400 && width > 1199) {
            if (colCount < 4) {
                $('.comparison-block__nav').addClass('d-none');
                $('.comparison-block__content').css('justify-content', 'center');
            }
            if (colCount >= 4) {
                $('.comparison-block__nav').removeClass('d-none');
                $('.comparison-block__content').css('justify-content', 'flex-start');
            }
        }
        if (width < 1700 && width > 1399) {
            if (colCount < 5) {
                $('.comparison-block__nav').addClass('d-none');
                $('.comparison-block__content').css('justify-content', 'center');
            }
            if (colCount >= 5) {
                $('.comparison-block__nav').removeClass('d-none');
                $('.comparison-block__content').css('justify-content', 'flex-start');
            }
        }
        if (width < 2200 && width > 1699) {
            if (colCount < 6) {
                $('.comparison-block__nav').addClass('d-none');
                $('.comparison-block__content').css('justify-content', 'center');
            }
            if (colCount >= 6) {
                $('.comparison-block__nav').removeClass('d-none');
                $('.comparison-block__content').css('justify-content', 'flex-start');
            }
        }
        if (width > 2199) {
            if (colCount < 7) {
                $('.comparison-block__nav').addClass('d-none');
                $('.comparison-block__content').css('justify-content', 'center');
            }
            if (colCount >= 7) {
                $('.comparison-block__nav').removeClass('d-none');
                $('.comparison-block__content').css('justify-content', 'flex-start');
            }
        }
    };

    function dotUpdate() {
        var width = $(window).width();
        var theDots = $('.comparison-block__content').closest('.comparison-block').find('.compare-dot-list .compare-dot-list__dot');
        var currentPosition = $('.comparison-block__content').scrollLeft();
        var colWidth = $('.comparison-block__content').find('.compare-item').width();
        var colCount = $('.comparison-block__content').find('.compare-item').length;
        var currentCol = Math.round(currentPosition / colWidth);

        $(theDots).each(function( i ) {
            $(this).removeClass('active');
        });
        if (width < 768) {
            $(theDots).slice( (currentCol), (currentCol + 1) ).addClass('active');
        }
        if (width < 1200 && width > 767) {
            $(theDots).slice( (currentCol), (currentCol + 2) ).addClass('active');
        }
        if (width < 1400 && width > 1199) {
            $(theDots).slice( (currentCol), (currentCol + 3) ).addClass('active');
        }
        if (width < 1700 && width > 1399) {
            $(theDots).slice( (currentCol), (currentCol + 4) ).addClass('active');
        }
        if (width < 2200 && width > 1699) {
            $(theDots).slice( (currentCol), (currentCol + 5) ).addClass('active');
        }
        if (width > 2199) {
            $(theDots).slice( (currentCol), (currentCol + 6) ).addClass('active');
        }
    }

    // Comparison table pagination ----------------------------------------

    // Shift left one column width
    $('.compare-btn-right').on('click', function () {
        var thisTable = $(this).closest('.comparison-block').find('.comparison-block__content');
        var thisColumn = $(this).closest('.comparison-block').find('.compare-item');
        var theDots = $(this).closest('.comparison-block').find('.compare-dot-list compare-dot-list__dot');
        var currentPosition = $(thisTable).scrollLeft();
        var colWidth = $(thisColumn).width() + 30;
        var colCount = $(thisColumn).length;
        var currentCol = Math.round(currentPosition / colWidth);

        if (currentCol < (colCount - 1)) {
            $(thisTable).scrollLeft(currentPosition + colWidth);
        }
    });

    // Shift right one column width
    $('.compare-btn-left').on('click', function () {
        var thisTable = $(this).closest('.comparison-block').find('.comparison-block__content');
        var thisColumn = $(this).closest('.comparison-block').find('.compare-item');
        var theDots = $(this).closest('.comparison-block').find('.compare-dot-list .compare-dot-list__dot');
        var currentPosition = $(thisTable).scrollLeft();
        var colWidth = $(thisColumn).width() + 30;
        var colCount = $(thisColumn).length;
        var currentCol = Math.round(currentPosition / colWidth);

        if (currentCol > 0) {
            $(thisTable).scrollLeft(currentPosition - colWidth);
        }
    });

    // Load up the comparision table ----------------------------------------
    $( document ).ready(function() {

        if($(".comparison-block")[0]) {
            buildDots();
            equalizeHeaders();

            var intervalCount = 0;
            var intervalId = window.setInterval(function(){
                equalizeHeaders();
                columnAdjust();
                dotUpdate();
                intervalCount++;
                if (intervalCount == 90) { // stop refreshing after 1.5 minutes
                    clearInterval(intervalId);
                    intervalId = 0;
                    intervalCount = 0;
                }
            }, 1000);
        }
    });

    // Comparison table responsive updates --------------------------------
    var width = $(window).width();
    $(window).resize(function () {
        var newWidth = $(window).width();

        if (newWidth !== width) {
            if($(".comparison-block")[0]) {
                equalizeHeaders();
                columnAdjust();
                dotUpdate();
            }
        }
    });

    //Update active dots based on scroll position and the number of columns
    $('.comparison-block__content').scroll(function(){
        // console.log('Scroll DETECTEED!');
        dotUpdate();
    });

    //Scrollspy for section nav ----------------------------------------------
    const sectionNav = document.querySelector('#sectionNav');

    if (sectionNav) {

        $('body').attr('data-bs-spy', 'scroll');
        $('body').attr('data-bs-target', '#sectionNav');
        $('body').attr('data-bs-offset', '95');

        var AnchornavToggleButton = $('#sectionNavCollapseToggle');
        var AnchornavDefaultButtonText = AnchornavToggleButton.text();
        var AnchornavMobileNav = $('.section-nav__list');

        //Resetting anchor links nav button text to default when no active scroll item
        $(window).on('scroll', function () {
            if (!AnchornavMobileNav.find('.active').length) {
                AnchornavToggleButton.html(AnchornavDefaultButtonText);
            }
        });

        //Updating button text to reflect active section
        $(window).on('activate.bs.scrollspy', function () {
            AnchornavToggleButton.html('');

            var activeButton = AnchornavMobileNav.find('.active');
            var buttonText = activeButton.text();
            AnchornavToggleButton.html(buttonText);
        });

        // var AnchornavItem = $('#sectionNavCollapse .section-nav__item');
        var AnchornavItem = $('#sectionNavCollapse .nav-link');

        // close section nav collapse when an item is clicked
        AnchornavItem.on('click', function (event) {
            var screenWidth = $(window).width();
            var anchorOffset = 80;

            if(screenWidth < 992) {
                anchorOffset = 80;
                $("#sectionNavCollapse").collapse('hide');
            }

            if(screenWidth > 991) {
                anchorOffset = 90;
            }

            event.preventDefault();
            var hash = $(this).attr('href');
            setTimeout(function() {
                var jumpTo = $(hash).offset().top - anchorOffset;
                window.location.hash = hash;
                $('html, body').animate({
                    scrollTop: jumpTo
                }, 150);
            }, 300);
        });
    }

     // side scrolling on tab block
     sideScrollTabs();

     var windowWidth = $(window).width();
     $(window).on('resize', function () {
         var newWindowWidth = $(window).width();
 
         if (windowWidth !== newWindowWidth) {
             sideScrollTabs();
         }
         windowWidth = newWindowWidth;
     });
 
     $('.tab-content-block__nav-right').on('click', function () {
         var currentButton = $(this);
         var theTabs = $(currentButton).closest('.tab-content-block__nav-wrap').find('.tab-content-block__nav');
         var currentPosition = $(theTabs).scrollLeft();
         var tabTotalWidth = 0;
         var tabSet = $(currentButton).closest('.tab-content-block__nav-wrap').find('.nav-item');
         $(tabSet).each(function () {
             tabTotalWidth += $(this).outerWidth();
         });
 
         $(theTabs).animate({
             scrollLeft: currentPosition + $(theTabs).width()
         }, 200);
     });
 
     $('.tab-content-block__nav-left').on('click', function () {
         var currentButton = $(this);
         var theTabs = $(currentButton).closest('.tab-content-block__nav-wrap').find('.tab-content-block__nav');
         var currentPosition = $(theTabs).scrollLeft();
         var tabTotalWidth = 0;
         var tabSet = $(currentButton).closest('.tab-content-block__nav-wrap').find('.nav-item');
         $(tabSet).each(function () {
             tabTotalWidth += $(this).outerWidth();
         });
 
         $(theTabs).animate({
             scrollLeft: currentPosition - $(theTabs).width()
         }, 200);
     });

})(jQuery);

// Equalize height of promo blocks in mega menu
function equalizeMegaMenuHeights() {
    // Check if the viewport width is greater than 992px
    if (window.innerWidth > 992) {
        // Select all mega menus (assuming they have a class 'mega-menu')
        const megaMenus = document.querySelectorAll('.mln__has-child--mega-menu');
        
        // Iterate through each active mega menu
        megaMenus.forEach(megaMenu => {
            // Find all elements with a specific class (e.g., 'promo-text-block') within this active mega menu
            const elements = megaMenu.querySelectorAll('.promo-text-block');
            
            // Get the heights of all elements
            const heights = Array.from(elements).map(el => el.offsetHeight);
            
            // Find the maximum height
            const maxHeight = Math.max(...heights);
            
            // Set the height of all elements to the maximum height
            elements.forEach(el => {
                el.style.minHeight = `${maxHeight}px`;
            });
        });
    }
}

// Usage example
equalizeMegaMenuHeights();


//tab content block scrolling
function sideScrollTabs() {
    $('.tab-content-block__nav').each(function () {
        var theTabs = $(this);
        var containerWidth = $(theTabs).width();
        var tabTotalWidth = 0;
        var rightBtn = $(theTabs).closest('.tab-content-block__nav-wrap').find('.tab-content-block__nav-right');
        var leftBtn = $(theTabs).closest('.tab-content-block__nav-wrap').find('.tab-content-block__nav-left');

        var tabSet = $(theTabs).find('.nav-item');
        $(tabSet).each(function () {
            tabTotalWidth += $(this).outerWidth();
        });

        if (tabTotalWidth > containerWidth) {
            $(rightBtn).addClass('active');
            $(leftBtn).addClass('active');
        } else {
            $(rightBtn).removeClass('active');
            $(leftBtn).removeClass('active');
        }
    });
}

// ****************************
// Run On Window Resize
// ****************************

// Set viewport function
function viewport() {
    var view = window;
    var viewString = 'inner';

    if (!('innerWidth' in window)) {
        viewString = 'client';
        view = document.documentElement || document.body;
    }

    return {
        width: view[viewString + 'Width'],
        height: view[viewString + 'Height']
    };
}

// Toggle location of elements in the DOM depending on screen size
function toggleDomLocation(el, containerSm, containerLg, breakpoint) {
    let $window = $(window);
    $(el).each(function () {
        var $this = $(this);
        if (viewport().width < breakpoint) {
            $this.appendTo($(containerSm));
        } else {
            $this.appendTo($(containerLg));
        }
        var windowWidth = $window.width();
        $window.on('resize', function () {
            var newWindowWidth = $window.width();

            if (windowWidth !== newWindowWidth) {
                if (viewport().width < breakpoint) {
                    $this.appendTo($(containerSm));
                } else {
                    $this.appendTo($(containerLg));
                }
            }

            windowWidth = newWindowWidth;
        });
    });
}

// Toggle location of utiilty nav in the DOM depending on screen size
toggleDomLocation('.utility-nav', '.js-utility-nav--mobile-parking', '.js-utility-nav--desktop-parking', 992);
// Toggle location of sign in dropdown toggle in the DOM depending on screen size
toggleDomLocation('.main-nav__sign-in-menu', '.js-sign-in--mobile-parking', '.js-sign-in--desktop-parking', 992);
// Toggle location of main nav logo in the DOM depending on screen size
toggleDomLocation('.main-nav__logo', '.js-main-logo--mobile-parking', '.js-main-logo--desktop-parking', 992);
// Toggle location of open account cta in the DOM depending on screen size
toggleDomLocation('.main-nav__account-cta', '.js-account-cta--mobile-parking', '.js-account-cta--desktop-parking', 992);
// Toggle location of open account cta in the DOM depending on screen size
toggleDomLocation('.nav-search__form', '.js-nav-search--mobile-parking', '.js-nav-search--desktop-parking', 992);
// Toggle location of footer social links in the DOM depending on screen size
// toggleDomLocation('.site-footer__social-links', '.js-footer-social--mobile-parking', '.js-footer-social--desktop-parking', 992);


// Multi Step Opti Form
    // This will add tick marks to the progress bar

$('.Form__NavigationBar__ProgressBar').each(function() {
    const $progressBar = $(this);
    const formSteps = $progressBar.closest('form').find('.FormStep');

    const progressTicks = $('<div class="Form__NavigationBar__ProgressBar--Ticks"></div>').appendTo($progressBar);

    formSteps.each(function(index) {
        if (index > 0) {
            const leftPost = ((100 / formSteps.length)) * index;
        
            $(`<span class="Form__NavigationBar__ProgressBar--Tick"></span>`).appendTo(progressTicks);
        }
    });
});

    // Moves the Submit button inline with the Progress Bar on the last page of multistep

    const  optiForm = document.querySelectorAll('.EPiServerForms');
    optiForm.forEach(item => {
        const formStepArray = item.querySelectorAll('section.FormStep');
    
        formStepArray.forEach((step, index) => {
            const formEl = step.closest('.EPiServerForms');
            const submitBtn = formEl.querySelector('.FormSubmitButton');
            const progressBarNav = formEl.querySelector('.Form__NavigationBar');
            const nextBtn = formEl.querySelector('.btnNext');
            
            if(index === (formStepArray.length - 1)){
                progressBarNav.appendChild(submitBtn);
            } 
        })

    })